export const messageContainerStyle = () => {
  return {
    alignSelf: 'flex-start',
    marginBottom: '16px',
    paddingLeft: '16px',
    paddingRight: '16px',
    maxWidth: '305px',
    clear: 'both',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: '0',
  };
};

export const messageWrapperStyle = () => {
  return {
    width: 'auto',
    flex: '1 1',
    alignSelf: 'flex-start',
    display: 'flex',
  };
};

export const messageThumbnailStyle = () => {
  return {
    width: '40px',
    height: '40px',
    margin: '0 5px 10px',
    float: 'left',
    flexShrink: '0',
  };
};

export const messageDetailStyle = () => {
  return {
    flex: '1 1',
    display: 'flex',
    flexDirection: 'column',
  };
};

export const messageTxtContainerStyle = () => {
  return {
    width: 'auto',
    flex: '1 1',
    display: 'flex',
    alignSelf: 'flex-start',
  };
};

export const messageTxtWrapperStyle = ({ theme }) => {
  return {
    display: 'inline-block',
    borderRadius: '4px 14px 14px 14px',
    backgroundColor: `${theme.backgroundColor.lightBlue3}`,
    color: `${theme.color.primary}`,
    padding: '16px',
    alignSelf: 'flex-start',
    width: 'auto',
    minHeight: '106px',
  };
};

export const messageInnerTxtContainerStyle = () => {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    img: {
      width: '35px',
    },
  };
};

export const messageTxtStyle = () => {
  return {
    margin: '0',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    textAlign: 'left',
    width: 'calc(100% - 30px)',
    fontSize: '14px',
    marginLeft: '8px',
  };
};

export const messageBtnStyle = (context) => {
  return {
    listStyleType: 'none',
    padding: '0',
    margin: '16px 0 0 0',
    width: '100%',
    li: {
      backgroundColor: `${context.theme.backgroundColor.white}`,
      borderRadius: '8px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      position: 'relative',
      margin: '0',
      padding: '8px',
      cursor: 'pointer',
      '> p': {
        background: '0 0',
        textAlign: 'center',
        color: `${context.theme.primaryColor}`,
        width: '100%',
        fontWeight: '600',
        display: 'inline-block',
        fontSize: '14px',
        margin: '0',
      },
    },
  };
};

export const messageInfoWrapperStyle = () => {
  return {
    alignSelf: 'flex-start',
    padding: '4px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '25px',
    gap: '2px',
  };
};

export const messageReactionsWrapperStyle = () => {
  return {
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    gap: '5px',
    paddingTop: '6px',
  };
};

export const iconStyle = (img, context) => {
  return {
    width: '30px',
    height: '24px',
    display: 'inline-block',
    mask: `url(${img}) center center no-repeat`,
    backgroundColor: `${context.theme.color.white}`,
  };
};
